<app-header></app-header>

<div class="container">
    <div class="box1">
    </div>
    <div class="box2">
        <div class="vendorSelected">
            <h3 class="titleVendor">Vendor: </h3>
            <p class="vendorName">{{vendorSelected.spFullName}}</p>
            <div class=" broker" *ngFor="let vendor of vendors; index as i ">
                <div class="aBroker" *ngIf="i==0 " (click)="changeVendor(i)">Broker: {{vendor.spFullName}}</div>
            </div>
        </div><br><br><br>
        <div *ngIf='vendors.length>1' class="vendorContainer">
            <div class="chooseVendor">
                <h5 class="choose">Choose your vendor:</h5>
            </div> <br>
            <div class="vendorNames" *ngFor="let vendor of vendors; index as i ">
                <li class="li" *ngIf="i!=0" (click)="changeVendor(i)">{{vendor.spFullName}}</li>
            </div>
        </div><br>
        <div *ngIf='vendors.length==1' class="noVendors">
            <h3>NO VENDORS TO SHOW!</h3>
        </div>
    </div>
    <div class="btnContinue" routerLink='/home'>Continue</div>
    <div class="box3">

    </div>
</div>

<app-footer></app-footer>
